export default __webpack_public_path__ + "static/media/foto-perfil.e028ba3d.jpg";